import React, { type FC, useState } from 'react';

import Card from '@amzn/meridian/card';
import Column from '@amzn/meridian/column';
import Expander from '@amzn/meridian/expander';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

import CardHeader, { type CardHeaderProps } from './cardHeader';

interface LimitationCardProps extends CardHeaderProps {
  duration?: number | null;
  frequency?: number | null;
  freeFormText?: string | null;
}

const LimitationCard: FC<LimitationCardProps> = ({ duration, frequency, freeFormText, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Card spacingInset="100 500" minWidth="750px">
      {!!duration || !!frequency || !!freeFormText?.length ? (
        <Expander
          type="list"
          open={isOpen}
          onChange={setIsOpen}
          title={<CardHeader {...props} additionalTags={[{ label: 'Non Physical', type: 'neutral' }]} />}
        >
          <Row spacing="600">
            {!!duration && (
              <Column spacing="200">
                <Text color="secondary">Duration</Text>
                <Text>{duration}</Text>
              </Column>
            )}

            {!!frequency && (
              <Column spacing="200">
                <Text color="secondary">Frequency</Text>
                <Text>{frequency}</Text>
              </Column>
            )}

            {!!freeFormText?.length && (
              <Column spacing="200">
                <Text color="secondary">Description</Text>
                <Text>{freeFormText}</Text>
              </Column>
            )}
          </Row>
        </Expander>
      ) : (
        <Row spacingInset="400 500">
          <CardHeader {...props} additionalTags={[{ label: 'Non Physical', type: 'neutral' }]} />
        </Row>
      )}
    </Card>
  );
};

export default LimitationCard;
